module.exports = __webpack_public_path__ + "static/media/blush.8df33715.png";